import { instance } from './axios.instance'
import { PROGRAM_ENDPOINT } from './endpoints'

/**
 * 교육실적 상세
 * GET /api/program/{id}
 * @param {string} id
 */
export const getProgramDetail = id => instance.get(PROGRAM_ENDPOINT.DETAIL(id))

/**
 * 교육실적 삭제
 * DELETE /api/program/{id}
 * @param {string} id
 */
export const deleteProgram = id => instance.delete(PROGRAM_ENDPOINT.DELETE(id))

/**
 * 교육실적 수정
 * PATCH /api/program/{id}
 * @param {string} id
 * @param {Object} data
 */
export const editProgram = (id, data) => {
    const formData = new FormData()
    const body = { ...data }
    delete body.files
    formData.append('body', JSON.stringify(body))

    if (data.files && data.files.length > 0) {
        data.files.forEach(file => {
            formData.append('files', file)
        })
    }
    return instance.patch(PROGRAM_ENDPOINT.EDIT(id), formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    })
}

/**
 * 교육실적 등록
 * POST /api/program/create
 * @param {Object} data
 */
export const createProgram = data => {
    const formData = new FormData()
    const body = data.map(item => {
        const { files, ...rest } = item
        return rest
    })
    formData.append('body', JSON.stringify(body))

    data.forEach(item => {
        if (item.files && item.files.length > 0) {
            item.files.forEach(file => {
                formData.append('files', file)
            })
        }
    })

    return instance.post(PROGRAM_ENDPOINT.CREATE, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    })
}
/**
 * 교육실적 목록
 * GET /api/program/list
 * @param {Object} params
 */
export const getProgramList = params => instance.get(PROGRAM_ENDPOINT.LIST, { params })
